import logger from './logger';

export async function retryWithBackoff<T>(
  fn: () => Promise<T>,
  maxRetries = 3,
  baseDelay = 1000
): Promise<T> {
  logger.debug('retry', 'Starting retry with backoff', { maxRetries, baseDelay });
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      logger.debug('retry', `Attempt ${i + 1}/${maxRetries}`);
      const result = await fn();
      logger.info('retry', `Attempt ${i + 1} succeeded`, { attempt: i + 1 });
      return result;
    } catch (error) {
      if (i === maxRetries - 1) {
        logger.error('retry', 'All retry attempts exhausted', error, { maxRetries, lastAttempt: i + 1 });
        throw error;
      }
      
      const delay = baseDelay * Math.pow(2, i);
      logger.warn('retry', `Attempt ${i + 1} failed, retrying after delay`, { 
        attempt: i + 1, 
        delay, 
        nextAttempt: i + 2,
        error: error instanceof Error ? error.message : String(error)
      });
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  
  logger.error('retry', 'Max retries exceeded (unexpected)', new Error('Max retries exceeded'), { maxRetries });
  throw new Error('Max retries exceeded');
}
